import React, { FC } from 'react'
import makeStyles from '@mui/styles/makeStyles';

import Avatar from '@mui/material/Avatar'

import {
  IData_MagicTag_Type,
} from '@kaidam/fc-shared/src/types/schema/magic_tag'

import {
  IconComponentType,
  IconProps,
} from '../../types/app'

import {
  MAGICTAG_TYPE_CRM,
  MAGICTAG_TYPE_ORG,
  MAGICTAG_COLORS,
} from '@kaidam/fc-shared/src/constants'

import icons from '../../icons'

const ContactIcon = icons.contact
const OrgIcon = icons.org

interface StyleProps {
  color: string,
}

const useStyles = makeStyles(theme => ({
  avatar: ({color}: StyleProps) => ({
    color: theme.palette.getContrastText(color),
    backgroundColor: color,
  }),
}))

interface MagicTagIconProps {
  type: IData_MagicTag_Type,
  avatar?: boolean,
  className?: string,
}

const ICONS: any = {
  [MAGICTAG_TYPE_CRM]: ContactIcon,
  [MAGICTAG_TYPE_ORG]: OrgIcon,
}

const MagicTagIcon: FC<React.PropsWithChildren<MagicTagIconProps>> = ({
  type,
  avatar = true,
  className,
}) => {

  const classes = useStyles({
    color: MAGICTAG_COLORS[type],
  })
  
  const Icon = ICONS[type]
  if(!Icon) return null

  const icon = <Icon className={ className } />

  return avatar ? (
    <Avatar className={classes.avatar}>
      { icon }
    </Avatar>
  ) : icon
}

export default MagicTagIcon